<template>
	<v-container class="pt-6">
	  <v-row justify="center" justify-md="start">
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" sm="8" md="4" lg="4" class="pb-1">
	  		<v-card class="elevation-0 shadowCard">
	  			<v-card-text>
	  				<v-row>
	  					<v-col cols="9" md="8" lg="9">
	  						<div>
			            <p class="mb-0 font-weight-bold">
			              {{ getGrupo.grupo.grupo_corto }}
			            </p>

			            <h5 class="mb-0 font-weight-bold text-h6 colorCurso" >
			              {{ getGrupo.escuela.curso }}<br/>
			            </h5>
		              <span class="text-sm font-weight-bolder grey--text">
		                <strong>{{ getGrupo.grupo.hora_inicio }} a {{ getGrupo.grupo.hora_fin }}</strong>
		              </span>
			          </div>
	  					</v-col>

	  					<v-col cols="3" md="4" lg="3" class="d-flex justify-end">
		            <v-avatar
			            size="60"
			            color="transparent"
			            rounded
			            class="elevation-1 avatares shadowCard"
			          >
			            <span class="text-h4 white--text">{{ getGrupo.grupo.id_nivel }}</span>
			          </v-avatar>
	  					</v-col>
	  				</v-row>
	  			</v-card-text>
	  		</v-card>
	  	</v-col>
	  	<v-col cols="12" sm="8" md="4" lg="4" class="pb-1">
			<!-- Boton para ir a los recusos -->
			<v-card class="shadowCard recursos mb-2" @click="verRecursos( )">
				<v-card-text>
					<v-row justify="center">
						<v-icon dark class="me-2">mdi-bookshelf</v-icon>
						<h5 class="mb-0 font-weight-bolder white--text text-h6" > Recursos </h5>
						<v-icon dark class="me-2">mdi-chevron-right</v-icon>
					</v-row>
				</v-card-text>
			</v-card>

			<!-- Boton para ver las calificaciones -->
			<v-card class="shadowCard calificaciones" @click="verCalificaciones( )">
				<v-card-text>
					<v-row justify="center">
						<v-icon dark class="me-2">mdi-school</v-icon>
						<h5 class="mb-0 font-weight-bolder white--text text-h6" >
						Calificaciones
						</h5>
						<v-icon dark class="me-2">mdi-chevron-right</v-icon>
					</v-row>
				</v-card-text>
			</v-card>

		</v-col>
		<v-col cols="12" sm="8" md="4" lg="4" class="pb-1" v-if="getGrupo.grupo.zoom">
			<v-card class="shadowCard" :href="obtenerURL(getGrupo.grupo.zoom)">
				<v-card-text class="py-2">
					<v-col cols="12" class="mb-1">
						<v-row justify="center" class="d-flex align-center">
							<v-img  class="me-2" contain max-height="25"
							max-width="25" src="../../assets/iconos/zoom.png"></v-img>
							<h5 class="mb-0 font-weight-bolder text-h6"><strong>Reunion de zoom</strong></h5>
							<v-icon>mdi-chevron-right</v-icon>
						</v-row>
					</v-col>
					<v-col cols="12">
						<v-row justify="center" class="d-flex align-center">
							<v-chip text-color="white" color="#208CFF" small>Clic para acceder!</v-chip>
						</v-row>
					</v-col>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
	<v-row justify="center">
	  	<!-- Información del grupo -->
	  	<v-col cols="6" sm="8" md="4" lg="4" class="pb-1">
	  		<Informacion/>
	  	</v-col>

	  	<!-- Ponderación -->
	  	<v-col cols="6" sm="8" md="4" lg="4" class="pb-1">
	  		<Ponderacion/>
	  	</v-col>

	  	<!-- Teachers -->
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" sm="8" md="4" lg="4" class="pb-1" v-if="getGrupo.teachers.teacher1 || getGrupo.teachers.teacher2">
	  		<Teachers/>
	  	</v-col>
	  </v-row>

	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'

  import Teachers      from '@/components/grupos/Teachers.vue'
  import Ponderacion   from '@/components/grupos/Ponderacion.vue'
  import Informacion   from '@/components/grupos/Informacion.vue'


	export default {
	  name: "dashboard-default",
	  data: () => ({
    	respuestaAlerta: false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
	  }),

	  components: {
	    Alerta,
	    Loader,
	    Teachers,
	    Ponderacion,
	    Informacion
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS' ])
	  },

	  created(){

	  	console.log( this.getGrupo )
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirCalificaciones' ] ),

	  	verRecursos ( ){
	  		this.cargar = true
	  		const payload = {
					id_usuario: this.getUsuarioLMS.id,
					id_curso:   this.getGrupo.grupo.id_curso,
					id_nivel:   this.getGrupo.grupo.id_nivel,
					id_grupo:   this.getGrupo.grupo.id,
					lecciones:  this.getGrupo.info_curso.dias_clase,
					tipo:       this.getGrupo.grupo.tipo
	  		}

	  		this.abrirRecursosAlumno( payload ).then(response => {
	  			this.cargar = false
	  		}).catch( error =>{
	  			this.cargar = false
    			if( error.status == 400 || error.status == 500 ){
      			this.parametros.mensaje      = error.body.message
	  				this.parametros.color        = '#FF2C2C'
      			this.parametros.dialogError  = true
      			this.respuestaAlerta = true
      		}
    		}).finally( () => { this.cargar = false })
	  	},


	  	verCalificaciones ( ){
	  		this.cargar = true
	  		const payload = {
	  			id_alumno: this.getUsuarioLMS.id,
	  			id_grupo : this.getGrupo.grupo.id,
	  			id_nivel : this.getGrupo.grupo.id_nivel
	  		}

	  		this.abrirCalificaciones( payload ).then(response => { this.cargar = false }).catch( error =>{
    			this.cargar = false
    			if( error.status == 400 || error.status == 500 ){
      			this.parametros.mensaje      = error.body.message
	  				this.parametros.color        = '#FF2C2C'
      			this.parametros.dialogError  = true
      			this.respuestaAlerta = true
      		}
    		}).finally( () => { this.cargar = false })
	  	},
		obtenerURL ( item ) {
		// Expresión regular para encontrar enlaces en el texto
			var expresionRegular = /https?:\/\/[^\s]+/g;
		// Usar el método match() para obtener todos los enlaces en un arreglo
			var enlaces = item.match(expresionRegular);

			return enlaces[0]
		}
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important;
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

	.recursos{
		background: rgb(233,186,255);
		background: linear-gradient(90deg, rgba(233,186,255,1) 0%, rgba(186,52,251,1) 100%);
	}

	.calificaciones{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.colorCurso{
		color: #006093;
	}

</style>
